import CitiesAPI  from "@/services/api/api-cities"

export default {
  namespaced: true,
  state: () => ({
    items: null,
  }),

  getters: {
    items: state => state.items,
    has: state => state.items ? true : false,
  },

  mutations: {
    set(state, items) {
      let formattedItem = items.map(location => {
        return {
          ...location,
          textToShow: `${location.name}`
        }
      })
      state.items = formattedItem
    },
  },

  actions: {
    async list({state, commit}, params) {
      try {
        if(params && params.cache && state.items) return state.items
        let res = await CitiesAPI.listCourseLocations({
          main_city: params.city
        })
        commit('set', res)
        return res
      } catch (error) {
        console.log(error, 'cityCourse')
        return Promise.reject(error)
      }
    },
  }
}
